import Button from '@/components/Buttons/Button';
import { pricingStudioUrl } from '@/environment';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const styles = {
    tooltip: {
        sx: {
            // we want to exclude dark mode behaviour here, if we want to include remove this important
            backgroundColor: '#FFF !important',
            color: theme.colors.secondary[900],
            boxShadow:
                '5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29), 2.4px 6.1px 8.6px -0.8px rgba(187, 187, 187, 0.23), 1.1px 2.8px 3.9px -0.4px rgba(187, 187, 187, 0.17), 0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.12)',
            padding: '16px',
            borderRadius: '8px',
        },
    },
};

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    p {
        font-weight: 600;
        line-height: 20px;
    }

    button {
        font-size: 14px;
        margin-left: auto;
        height: 34px;
    }
`;

interface Props {
    text: string;
    title?: string;
    onUpgradeClick?: () => void;
}

const DEFAULT_TITLE = 'Upgrade needed';

export const UpgradeNeededTooltipContent = ({ title = DEFAULT_TITLE, text, onUpgradeClick }: Props) => {
    const handleClick = () => {
        onUpgradeClick?.();
        window.open(pricingStudioUrl, '_blank');
    };

    return (
        <StyledContainer>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="body1">{text}</Typography>
            <Button onClick={handleClick}>Explore plans</Button>
        </StyledContainer>
    );
};
